import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Maximize2, PhoneOff } from 'lucide-react';
import { selectActiveCall, activeCallCleared } from '@/features/calls/callsSlice.js';
import { useEndCallMutation } from '@/features/calls/callsApi.js';

export function ActiveCallOverlay() {
  const active = useSelector(selectActiveCall);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [endCall] = useEndCallMutation();

  if (!active) return null;
  if (location.pathname === `/call/${active.callId}`) return null;

  const handleEnd = async () => {
    try {
      await endCall({ callId: active.callId }).unwrap();
    } catch {
      // ignore — server may already mark it ended
    }
    dispatch(activeCallCleared());
  };

  return (
    <div className="fixed left-1/2 top-2 z-40 flex -translate-x-1/2 items-center gap-2 rounded-full bg-emerald-600 px-4 py-2 text-white shadow-lg">
      <span className="text-sm font-medium">{active.peer?.name ?? 'Звонок'}</span>
      <button
        type="button"
        onClick={() => navigate(`/call/${active.callId}`)}
        aria-label="Развернуть звонок"
        className="rounded-full bg-white/20 p-1.5"
      >
        <Maximize2 className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={handleEnd}
        aria-label="Завершить звонок"
        className="rounded-full bg-red-500 p-1.5"
      >
        <PhoneOff className="h-4 w-4" />
      </button>
    </div>
  );
}
